import { Image, Link, Text } from '@weareconceptstudio/core';

//* Styles
import RecipesItemStyle from './style';

//* Helpers
import { config } from '@/helpers';

const RecipesItem = ({ title, slug, image, tag, tags = [] }) => {
	return (
		<RecipesItemStyle className='recipes-item-wrapper'>
			<Link
				url={`${config.routes.recipes.path}${slug}`}
				className='recipes-item-link-wrapper'
			>
				<div className='recipes-item-inner-wrapper'>
					<div className='recipes-item-image-wrapper'>
						<Image
							src={image.src}
							alt={image.alt}
						/>
					</div>

					<div className='recipes-item-info-wrapper'>
						<div className='recipes-item-info-inner-wrapper'>
							<Text className='p5 green-1000 font-fss-light tag-text'>{tag || 'TAG'}</Text>

							<Text className='p4 green-1000 font-larken-regular banner-text'>{title}</Text>
						</div>
					</div>
				</div>
			</Link>
		</RecipesItemStyle>
	);
};

export default RecipesItem;
